module.exports = __webpack_public_path__ + "img/28_53.965d18c1.png";